import { AnagraficaApi, ApiAnagraficaNdgDettaglioGetRequest, ApiCertificazioneCertificazioniNdgDettaglioGetRequest, ApiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRequest, CertificazioneApi, CertificazioneDto, CertificazioneEmailApi, CertificazioneEmailDto, CertificazioniDettaglioDto, ClienteDto, Configuration } from '@desio/api';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "store";
import getConfiguration, { errorHandler } from "store/config";

export const getFlagButtonAvviaCertificazione = createAsyncThunk<CertificazioniDettaglioDto | undefined, number, ThunkApiConfig>(
  'certificazione/getFlagButtonAvviaCertificazione', async (ndg, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/post-ricerca-processi.json')).default;
      } else {
        const request: ApiCertificazioneCertificazioniNdgDettaglioGetRequest = {
          ndg: ndg
        }
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneCertificazioniNdgDettaglioGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getInviaEmail = createAsyncThunk<CertificazioneEmailDto | undefined, number, ThunkApiConfig>(
  'certificazione/getInviaEmail', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/post-ricerca-processi.json')).default;
      } else {
        const request: ApiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRequest = {
          idCertificazioneEmail: id
        }
        return await new CertificazioneEmailApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneEmailIdCertificazioneEmailInviaEmailGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getAvvioCertificazione = createAsyncThunk<CertificazioneEmailDto | void, number, ThunkApiConfig>(
  'certificazione/getAvvioCertificazione', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return {

        };
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneIdAvvioGet({ id });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const resetResultAvvioCertificazione = createAction<void, 'resetResultAvvioCertificazione'>('resetResultAvvioCertificazione');

export const getDettaglioCliente = createAsyncThunk<ClienteDto | undefined, number, ThunkApiConfig>(
  'anagrafica/getDettaglioCliente', async (ndg, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-anagrafica-utente.json')).default;
      } else {
        const obj: ApiAnagraficaNdgDettaglioGetRequest = { ndg }
        return await new AnagraficaApi(getConfiguration(Configuration, extra, getState)).apiAnagraficaNdgDettaglioGet(obj);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getElencoCertificazioniCliente = createAsyncThunk<Array<CertificazioneDto> | undefined, number, ThunkApiConfig>(
  'certificazione/getElencoCertificazioniCliente', async (ndg, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-elenco-certificazioni.json')).default;
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneCertificazioniNdgGet({ ndg });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
